module.exports = __webpack_public_path__ + "img/logo.e593c36b.png";